import React from 'react';

const toneStyles = {
  positive: {
    border: 'border-signal-green/20',
    bg: 'bg-signal-green/5',
    headlineColor: 'text-signal-green',
    icon: '✓',
  },
  cautious: {
    border: 'border-signal-yellow/20',
    bg: 'bg-signal-yellow/5',
    headlineColor: 'text-signal-yellow',
    icon: '⚠',
  },
  elevated: {
    border: 'border-signal-orange/20',
    bg: 'bg-signal-orange/5',
    headlineColor: 'text-signal-orange',
    icon: '🔶',
  },
  danger: {
    border: 'border-signal-red/20',
    bg: 'bg-signal-red/5',
    headlineColor: 'text-signal-red',
    icon: '⛔',
  },
};

export default function SignalSummary({ summary }) {
  if (!summary) return null;

  const style = toneStyles[summary.tone] || toneStyles.positive;

  return (
    <div className={`glass-card ${style.bg} border ${style.border} p-6 animate-slide-up`}>
      <div className="flex items-start gap-3">
        <span className="text-2xl mt-0.5 flex-shrink-0">{style.icon}</span>
        <div>
          <h3 className={`font-display font-bold text-lg ${style.headlineColor} mb-2`}>
            {summary.headline}
          </h3>
          <p className="text-mentor-text/90 font-body leading-relaxed text-[0.95rem]">
            {summary.body}
          </p>
        </div>
      </div>
    </div>
  );
}
